import { times } from 'lodash';

import {
  advancedSearchFormRowCount,
  BooleanOperator,
  defaultAdvancedSearchRowState,
  FormValues,
} from '../constants';

export const getFormValuesObject = (
  rowCount = advancedSearchFormRowCount
): FormValues => {
  const rows = {};

  times(rowCount, index => {
    rows[index] = {
      ...defaultAdvancedSearchRowState,
      ...(index > 0 && { booleanOperator: BooleanOperator.and }),
    };
  });

  return rows;
};
